function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.250977 3.31464C0.250977 1.6771 1.57847 0.349609 3.21601 0.349609H7.99278L12.8943 5.25116V13.3846C12.8943 15.0221 11.5668 16.3496 9.9293 16.3496H3.21601C1.57847 16.3496 0.250977 15.0221 0.250977 13.3846V3.31464ZM3.21601 1.80415C2.38179 1.80415 1.70552 2.48042 1.70552 3.31464V13.3846C1.70552 14.2188 2.38179 14.8951 3.21601 14.8951H9.9293C10.7635 14.8951 11.4398 14.2188 11.4398 13.3846V6.27968H9.9293C8.29175 6.27968 6.96426 4.95219 6.96426 3.31464V1.80415H3.21601ZM8.41881 2.83267L10.4113 4.82513H9.9293C9.09508 4.82513 8.41881 4.14887 8.41881 3.31464V2.83267Z",
  fill: "#249AF3"
});

function SvgDocumentOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOutlined);
export default __webpack_public_path__ + "static/media/DocumentOutlined.c30f0ec8.svg";
export { ForwardRef as ReactComponent };